import { faCircleInfo, faCircleQuestion, faFlag, faGear, faHeart, faRightFromBracket, faUserCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@remix-run/react";

interface MobileSignedInHeaderProps {
    setMobileMenuOpen: (open: boolean) => void;
    mobileMenuOpen: boolean;
}

const MobileSignedInHeader: React.FC<MobileSignedInHeaderProps> = ({ setMobileMenuOpen, mobileMenuOpen }) => {
    return (
        <header id="mobile-header" className="block lg:hidden fixed inset-x-0 z-20 bg-background-dark top-0">
            <nav aria-label="Global" className="flex items-center justify-between p-3">
                <div className="flex flex-1">
                    <a href="/" className="-m-1.5 p-1.5 flex items-end">
                        <span className="sr-only">MarketDataFyi</span>
                        <img
                            alt="MarketDataFyi"
                            src="/mdfyi-logo.png"
                            className="h-[30px]"
                        />
                        <span className="ml-1 text-[10px] font-normal text-gray-800 opacity-75">
                            Beta!
                        </span>
                    </a>
                </div>
                <div className="flex lg:hidden">
                    <FontAwesomeIcon
                        icon={faUserCircle}
                        onClick={() => setMobileMenuOpen(true)}
                        className="text-2xl cursor-pointer text-gray-600"
                    />
                </div>
            </nav>

            {/* Overlay */}
            <div
                role="button"
                tabIndex={0}
                className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out z-40
                    ${mobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setMobileMenuOpen(false)}
            />

            {/* Off-canvas menu */}
            <div
                className={`fixed inset-y-0 right-0 z-50 w-[70%] bg-white transform transition-transform duration-300 ease-in-out
                    ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
            >
                <div className="p-4">
                    <div className="flex items-center justify-end">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Close menu</span>
                            <FontAwesomeIcon icon={faXmark} className="h-6 w-6" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6">
                            <div className="space-y-2 py-6 text-sm font-semibold text-gray-700">
                                <Link
                                    to="/settings"
                                    className="-mx-3 block rounded-lg px-3 py-1 leading-7"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <FontAwesomeIcon icon={faGear} className="text-lg inline-block mr-2" />
                                    Settings
                                </Link>
                                <div className="border-b border-gray-200"></div>
                                <Link
                                    to="/faqs"
                                    className="-mx-3 block rounded-lg px-3 py-1 leading-7"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <FontAwesomeIcon icon={faCircleQuestion} className="text-lg inline-block mr-2" />
                                    FAQs
                                </Link>
                                <div className="border-b border-gray-200"></div>
                                {/* <Link
                                    to="/report-issue"
                                    className="-mx-3 block rounded-lg px-3 py-1 leading-7"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <FontAwesomeIcon icon={faFlag} className="w-4 h-4 inline-block mr-2" />
                                    Report an Issue
                                </Link> */}
                                {/* <div className="border-b border-gray-200"></div> */}
                                <Link
                                    to="/sign-out"
                                    className="-mx-3 block rounded-lg px-3 py-1 leading-7"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <FontAwesomeIcon icon={faRightFromBracket} className="w-4 h-4 inline-block mr-2" />
                                    Sign out
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default MobileSignedInHeader;

